import script from "./CameraInstructions.vue?vue&type=script&setup=true&lang=js"
export * from "./CameraInstructions.vue?vue&type=script&setup=true&lang=js"

import "./CameraInstructions.vue?vue&type=style&index=0&id=2a9238ff&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2a9238ff"]])

export default __exports__